const steps = {
	stepProject: {
		title: 'Project information',
		platformType: 'Platform type',
		tourism: 'Tourism',
		pms: 'Multiservice',
		nomProjet: 'Project name *',
		nomPass: 'Pass name *',
		territoire: 'Area *',
		helpNomProjet: 'Project name in lower case, no accents, spaces or special characters (hyphen allowed)',
		helpNomPass: 'Official name of the offer',
		helpTerritoire: 'Geographic area',
		phNom: 'E.g. sete',
		phPass: 'E.g. SAM Pass',
		phTerr: 'E.g. Sète area',
	},
	stepIssuer: {
		title: 'Issuer information',
		nom: 'Full issuer name *',
		helpNom: 'Full name of the issuer (legal entity)',
		ref: 'Reference *',
		helpRef: 'Abbreviation in capitals',
		adresse: 'Public postal address *',
		helpAdresse: 'If several lines, separate with a comma',
		cp: 'Postal code *',
		ville: 'City *',
		pays: 'Country *',
		paysAutrePh: 'Specify the country',
		tel: 'Public phone:',
		helpTel: 'Public line for the issuer',
		site: 'Public institutional website *',
		helpSite: "Issuer's website",
		domaine: 'Domain *',
		emailBlock: 'Email addresses',
		emailPublic: 'Public contact email *',
		emailNotif: 'Email for automatic notifications *',
		socialBlock: 'Social media',
		facebook: 'Facebook:',
		youtube: 'YouTube:',
		instagram: 'Instagram:',
		x: 'X:',
	},
	services: {
		title: 'Services',
		dechetterie: 'Recycling centre',
		piscine: 'Pool / sports centre',
		mediatheque: 'Media library',
		musee: 'Museum / tourist activity',
		transport: 'Transport',
		autres: 'Other:',
		transportOffer: 'Does the Pass include a transport offer?',
		operator: 'Who is the transport operator?',
		operatorPh: 'Specify the operator',
		durationQ: 'Does the transport offer include different durations?',
		phService: 'E.g. car park',
	},
	tourist: {
		title: 'Tourist data',
		alim: 'Should the platform be fed from a tourist data platform?',
		editor: 'Who is the tourist data platform provider?',
		editorPh: 'Specify the provider',
		freq: 'Sync frequency:',
		freqPh: 'Specify the frequency',
	},
	support: {
		visuelTitle: 'Pass artwork',
		visuelQ: 'Do you already have artwork for the Pass?',
		chooseFile: 'Choose a file',
		fileSelected: 'Selected file:',
		altVisuel: 'Pass artwork',
		supDematTitle: 'Digital pass',
		supDematQ: 'Will the Pass be available digitally?',
		supPhysTitle: 'Physical pass',
		supPhysQ: 'Will the Pass be available in physical form?',
		id1: 'Pass IDs (front) - ID 1',
		id1prec: 'Specify:',
		id1ph: 'Specify the ID',
		id2: 'Pass IDs (back) - ID 2',
	},
	devices: {
		title: 'Reader devices',
		presta: 'Are your partners already equipped with reading devices?',
		typeLecture: 'Read type:',
		qr: 'QR code',
	},
	website: {
		title: 'Pass website (front office)',
		ordered: 'Have you ordered the Otipass front office?',
		langs: 'Languages and translations:',
		domainQ: 'If you have already chosen a domain name, what is it?',
		bookQ: 'Have you already reserved it?',
		operator: 'Specify the operator',
		phOp: 'E.g. Gandi, OVH',
	},
	social: {
		title: 'Pass social media',
		fb: 'Facebook page:',
		yt: 'YouTube:',
		ig: 'Instagram:',
		x: 'X:',
	},
	subscriptions: {
		title: 'Online registration & shop',
		passGratuit: 'Do you offer a free Pass?',
		insBlock: 'Online registration (free Pass)',
		existingForm: 'Is there already an online form for new users to register?',
		urlForm: 'What is its URL?',
		otipassForm: 'Do you plan to enable the Otipass online registration form?',
		otipassFeat: 'Otipass registration form features',
		pjTypes: 'Requested supporting document types',
		pjOtherPh: 'Specify another document type',
		passPayant: 'Do you offer a paid Pass?',
		boutiqueBlock: 'Online shop (paid Pass)',
		existingShop: 'Is there already a shop to sell the Pass online?',
		editorShop: "Who is the current shop's provider?",
		urlShop: 'What is its URL?',
		otipassShop: 'Do you plan to enable the Otipass online shop?',
		otipassShopFeat: 'Otipass shop features',
		conditions: 'Specify the conditions',
		paymentGws: 'Payment gateways',
		gwOther: 'Specify the payment gateway',
		userData: 'Collected user data',
		uid: 'Unique identifier (UID) — select fields',
		obligatoire: 'required',
	},
	finance: {
		title: 'Financial management',
		currencies: 'Currencies',
		periodEntrees: 'Reporting frequency (entries)',
		periodVentes: 'Reporting frequency (sales)',
	},
	various: {
		title: 'Languages, colours and other',
		backLangs: 'Languages and translations on the back office:',
		primary: 'Primary brand colour:',
		secondary: 'Secondary colour:',
		mobile: 'Have you ordered the mobile app for pass holders?',
		phColor: 'E.g. #0090AA',
		phColor2: 'E.g. #FF6600',
	},
	contacts: {
		title: 'Contacts',
		tabCoord: 'Coordinator',
		tabCoordDesc: 'Project coordinator',
		tabTech: 'Technical',
		tabTechDesc: 'Web integration technical contact',
		tabData: 'Tourist data',
		tabDataDesc: 'Tourist data integration (Apidae, Tourinsoft)',
		tabCompta: 'Accounting',
		tabComptaDesc: 'Accounting lead',
		tabAutre: '•••',
		tabAutreDesc: 'Other / specify',
		lastname: 'Last name',
		firstname: 'First name',
		email: 'Email address',
		tel1: 'Tel. 1',
		tel2: 'Tel. 2',
		function: 'Role',
	},
	formulas: {
		title: 'Plans',
		add: 'Add a plan',
	},
};

export default steps;
